// This adapter captures local env config when running the dev server (pnpm start) and the webpack build,
// supporting runtime override with HTML Data runtime config.

// If in a browser with "document" defined, get the value from document.head.dataset, otherwise a default value from build-time.
export default function tryRuntimeConfig(varName) {
  if (
    typeof document !== 'undefined' &&
    typeof document.head.dataset[varName] !== 'undefined'
  ) {
    return document.head.dataset[varName]
  }
  return buildConfig[varName]
}

const buildConfig = {
  public_web_dashboard_app_url: process.env.PUBLIC_WEB_DASHBOARD_APP_URL,

  public_web_data_redirect_to_dashboard:
    process.env.PUBLIC_WEB_DATA_REDIRECT_TO_DASHBOARD,

  public_web_front_end_auth_url: process.env.PUBLIC_WEB_FRONT_END_AUTH_URL,

  public_web_herokudata_backend: process.env.PUBLIC_WEB_HEROKUDATA_BACKEND,

  public_web_logout_url: process.env.PUBLIC_WEB_LOGOUT_URL,

  public_web_platform_api_url: process.env.PUBLIC_WEB_PLATFORM_API_URL,

  public_web_sentry_client_environment:
    process.env.PUBLIC_WEB_SENTRY_CLIENT_ENVIRONMENT,

  public_web_sentry_dsn: process.env.PUBLIC_WEB_SENTRY_DSN,

  public_web_shogun_api_url: process.env.PUBLIC_WEB_SHOGUN_API_URL,

  public_web_url: process.env.PUBLIC_WEB_URL
}
